'use strict';

function componentMultiUpload(g) {
  var uploadArea = $('#acf-upload-area');

  var progressBar = uploadArea.find('progress');
  var fileList = uploadArea.find('#file-list');
  var error = uploadArea.find('#error');
  var hiddenFileUploaded = uploadArea.find('#file-just-uploaded');

  function initMultiUpload() {

    interceptValidation();

    uploadArea.dmUploader({
      url: uploadArea.data('action'),
      auto: false,
      dnd: false,
      queue: true,
      maxFileSize: 1024 * 1024 * uploadArea.data('max-size'),
      extFilter: uploadArea.data('mime-type').split(','),
      extraData: {
        action: 'acf_multi_upload'
      },
      onInit: function() {},
      onNewFile: function() {
        setTimeout(function() {
          viewUploadFile();
        }, 250);
      },
      onFileSizeError: function() {
        showError('error-file-weight');
      },
      onFileExtError: function() {
        showError('error-file-type');
      },
      onBeforeUpload: function() {
        progressBar.attr({value: 0}).text(0);
      },
      onUploadProgress: function(id, percent) {
        progressBar.attr({value: percent}).text(percent);
      },
      onUploadSuccess: function(id, data) {
        var hidden = $('<input />').attr({
          'type': 'text',
          'name': uploadArea.data('name'),
          'value': data.files[0],
          'data-id-uploade': id
        });

        hiddenFileUploaded.append(hidden);

        if (uploadArea.data('dmUploader').queue.length === hiddenFileUploaded.find('input').length) {
          uploadArea.closest('form').submit();
        }
      },
      onUploadError: function() {
        showError('error-server');
      },
      onUploadComplete: function() {
        progressBar.attr({value: 0}).text(0);
      }
    });

    fileList.on('click', 'button[data-delete]', function() {
      deleteUploadFile($(this).data('id'));
    });
  }

  function interceptValidation() {
    acf.add_filter('validation_complete', function( json, form ){

      // Quand l'objet change, on supprime le message d'erreur PJ et le required PJ
      $('#acf-key_contact_courtier_remboursement, #acf-key_contact_courtier_contratinfo').change(function () {
        var fieldsUpload = acf.findFields({
          type: 'multi_upload'
        });
        var fieldUpload = $(fieldsUpload[0]);

        if( fieldUpload[0].querySelector('.acf-error-message') != null) {
          fieldUpload.removeData( "required" );
          fieldUpload[0].querySelector('.acf-error-message').remove();
        }
      });

      var fieldsUpload = acf.findFields({
        type: 'multi_upload'
      });

      if( fieldsUpload.length ) {
        var fieldUpload = $(fieldsUpload[0]);
        var fieldUploadArea = fieldUpload.find('#acf-upload-area');

        // rendre les pj obligatoires
        var containerObjetRemb = acf.findField('key_contact_courtier_remboursement')[0];
        var containerObjetCont = acf.findField('key_contact_courtier_contratinfo')[0];
        var listePjObligatoireRemb = [
          "Envoyer des décomptes, des factures",
          "Envoyer un devis dentaire, de dépassement d'honoraire"
        ];
        var listePjObligatoireCont = [
          "Envoyer une attestation de droit Sécurité Sociale",
        ];

        //Si objet = remboursement
        if (!containerObjetRemb.hidden) {
          var valSelectedObjetRemb = containerObjetRemb.querySelector('#select2-acf-key_contact_courtier_remboursement-container');
          if (listePjObligatoireRemb.indexOf(valSelectedObjetRemb.title) >= 0) {
            fieldUpload.data('required',1);
          }
        }

        //Si objet = contrat
        if (!containerObjetCont.hidden) {
          var valSelectedObjetCont = containerObjetCont.querySelector('#select2-acf-key_contact_courtier_contratinfo-container');
          if (listePjObligatoireCont.indexOf(valSelectedObjetCont.title) >= 0) {
            fieldUpload.data('required', 1);
          }
        }

        if (fieldUpload.data('required') === 1 && fieldUploadArea.data('dmUploader').queue.length === 0) {
          if (!json.errors) {
            json = {valid: 0, errors: []};
          }

          json.errors.push({input: fieldUploadArea.data('id'), message: 'Vous devez ajouter au moins 1 fichier'});
        }

        if (!json.errors && fieldUploadArea.data('dmUploader').queue.length > 0) {
          form.submit(function () {
            if (fieldUploadArea.data('dmUploader').queue.length === fieldUploadArea.find('#file-just-uploaded input').length) {
              return true;
            }
            return false;
          });

          fieldUploadArea.dmUploader('start');
        }
      }

      return json;
    });
  }

  function viewUploadFile() {
    fileList.empty();

    var queue = uploadArea.data('dmUploader').queue;

    if (queue.length > uploadArea.data('max-file')) {
      queue = queue.slice(0, uploadArea.data('max-file'));
      uploadArea.data('dmUploader').queue = queue;

      showError('error-max-file');
    }

    $.each(queue, function(key, val) {
      var fileName = val.data.name;
      var fileRow = $('<div>');

      fileRow.append(
        $('<button data-delete type="button">')
          .attr('data-id', val.id)
          .html('x')
      );
      fileRow.append('<span>' + fileName + '</span>');
      fileList.append(fileRow);
    });

    if (queue.length) {
      fileList.removeClass('is-hidden');
    } else {
      fileList.addClass('is-hidden');
    }
  }

  function deleteUploadFile(id) {
    var queue = [];

    $.each(uploadArea.data('dmUploader').queue, function(key, val) {
      if (val.id !== id) {
        queue.push(val);
      }
    });

    $('.filename[data-id="' + id + '"]').remove();

    uploadArea.data('dmUploader').queue = queue;

    viewUploadFile();
  }

  function showError(errorId) {
    error.find('div').addClass('is-hidden');

    error
      .removeClass('is-hidden')
      .children('#' + errorId)
      .removeClass('is-hidden');
  }

  initMultiUpload();
}
